/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

var NavDivider = function NavDivider(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("hr", {
    className: classnames('cpc--side-nav__divider', className)
  });
};
NavDivider.propTypes = {
  /**
   * The class name to apply to the nav item's li element.
   */
  className: PropTypes.string
};
var NavDivider$1 = NavDivider;

export { NavDivider$1 as default };
